/*
* Project: LegalPlace assistant
* File: src/components/buy/card_modal.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


import React, { Component } from 'react';
import { connect } from 'react-redux';
import MaskedInput from '../misc/masked_input';
import {
  ckPaymentSelect, ckCUpdateCardNumber, ckCUpdateCardExpiration, ckCUpdateCCV, CK_CHECK,
} from '../../redux/actions/checkout_operations';
import { store } from '../../globals';
import lpevents from '../../tracking/lpevents';
import { raiseError, unraiseError } from '../../errors/error';
import { checkingPayment } from '../../redux/actions/loading';
import { getCardClass } from '../utils/credit_card_detect';
import { lpPattern, P_CLOSE_PAIMENT, P_PAY } from '../../tracking/pattern_detector';
import { _lp } from '../../logic/wording';
import lpApp from '../../app/lp_app';

// intiialization of errors payment errors
function initErrors() {
  unraiseError('credit-error');
  unraiseError('credit.number');
  unraiseError('card.exp');
  unraiseError('card.cvc');
  // unraiseError('')
}

class _LpCreditCardModal extends Component {
  constructor(props) {
    super(props);
    this.updateCardNumber = this.updateCardNumber.bind(this);
    this.updateCardExpiration = this.updateCardExpiration.bind(this);
    this.updateCardCCV = this.updateCardCCV.bind(this);
    this.initiatePayment = this.initiatePayment.bind(this);
    this.updateCheckBox = this.updateCheckBox.bind(this);

    // do the changes in the card type
    this.state = {
      card_class: 'none',
    };
  }

  componentDidMount() {
    const that = this;
    const a = document.getElementById('checkout-modal1');

    document.getElementById('checkout-modal1').addEventListener('click', (e) => { if ((e.target === a) || (e.target === that.close_btn)) { this.props.closeEvent(); lpApp.ops.checkout.resetCreditCardInformation(); }lpPattern.trackInPayment(P_CLOSE_PAIMENT); });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      if (this.refs.credit_card_modal) {
        if (document.getElementById('checkout-modal1').firstChild) document.getElementById('checkout-modal1').removeChild(document.getElementById('checkout-modal1').firstChild);
        document.getElementById('checkout-modal1').appendChild(this.refs.credit_card_modal);
        document.getElementById('checkout-modal1').classList.add('lp-modal');
        document.getElementsByClassName('page-wrap')[0].style.filter = 'blur(5px)';
        document.body.style.overflow = 'hidden';
        lpApp.ops.utils.addModalClassToBody();
      }
    }
    if (prevProps.show && !this.props.show) {
      document.getElementById('checkout-modal1').classList.remove('lp-modal');
      document.getElementsByClassName('page-wrap')[0].style.filter = 'none';
      document.body.style.overflow = 'auto';
      lpApp.ops.utils.removeModalClassToBody();
    }

    const that = this;
    const a = document.getElementById('checkout-modal1');

    document.getElementById('checkout-modal1').addEventListener('click', (e) => { if ((e.target === a) || (e.target === that.refs.close_btn)) { this.props.closeEvent(); lpApp.ops.checkout.resetCreditCardInformation(); }lpPattern.trackInPayment(P_CLOSE_PAIMENT); });
    const paypal = window.paypal
    if (paypal && !document.querySelector('.paypal-buttons') && document.querySelector('#paypal-container')) {
      paypal.Buttons({
        style: {
          color: 'silver',
          fundingicons: 'false',
          layout: 'horizontal',
          tagline: 'false'
        },
        onClick: (data, actions)  => {
          this.props.updatePaymentMethod(1)
          if (!this.props.confirmation) {
            raiseError('credit-error', 20, _lp("Vous devez lire et accepter nos conditions générales de vente et d'utilisation."));
            return actions.reject()
          }
        },
        createOrder: (data, actions) => (actions.order.create({
          purchase_units: [{
            amount: {
              currency_code: 'EUR',
              value: contract_meta_id === 302 ? this.props.totalTTC : lpApp.ops.checkout.getTTCPrice()
            }
          }]
        })),
        onApprove: (data, actions) => {
          return actions.order.capture().then((response) => {
            this.initiatePayment(data.orderID, response.payer.email_address)
          })
        },
      }).render('#paypal-container')
    }
  }

  componentWillUnmount() {
    if (document.getElementById('checkout-modal1').firstChild) document.getElementById('checkout-modal1').removeChild(document.getElementById('checkout-modal1').firstChild);
    document.getElementById('checkout-modal1').classList.remove('lp-modal');
    document.getElementsByClassName('page-wrap')[0].style.filter = 'none';
    document.body.style.overflow = 'auto';
    lpApp.ops.utils.removeModalClassToBody();
  }

  // TODO: better things.
  updateCardNumber(evt) {
    this.props.updateCardNumber(evt.target.value);
    this.setState({ card_class: getCardClass(evt.target.value) });
  }

  updateCardExpiration(evt) {
    this.props.updateCardExpiration(evt.target.value);
  }

  updateCardCCV(evt) {
    this.props.updateCardCCV(evt.target.value);
  }

  updateCheckBox(evt) {
    this.props.updateConfirmation(evt.target.checked);
  }

  totalRevenue() {

    return this.props.contract_meta_id === 302 ? this.props.coursier_pack_price : lpApp.ops.checkout.getHTPrice()
    // const  htPrice = lpApp.ops.checkout.getHTPrice()
    // const deducedFees = Object.keys(HARDCODED_FEES_PER_META_IDS).indexOf(`${lpApp.contractMetaId}`) > -1
    // ? HARDCODED_FEES_PER_META_IDS[`${lpApp.contractMetaId}`]
    // : 0

    // return htPrice - deducedFees
  }

  initiatePayment(orderId = null, paypalAddress = '') {
    // if(this.props.confirmation){
    this.props.loading();
    initErrors();
    // pattern.
    lpPattern.trackLastAction(P_PAY);
    lpPattern.sendAndResetTracker();

    let selectedPack;

    switch (this.props.selected_pack) {
      case 0:
        selectedPack = 'first_price';
        break;
      case 1:
        selectedPack = 'second_price';
        break;
      default:
        selectedPack = 'third_price';
        break;
    }

    const totalTTC = this.props.contract_meta_id === 302 ? this.props.totalTTC : lpApp.ops.checkout.getTTCPrice()
    let datalayerData = {}
    // devenir-coursier only
    if ([302].indexOf(this.props.contract_meta_id) > -1) {
    const priceTva = (totalTTC * (1/6)).toFixed(2)
    const priceHT = (totalTTC - priceTva).toFixed(2)
    datalayerData = {
      orderShipping:0,
      packPriceWithReduction: priceHT,
      orderTax: priceTva,
      acteProduct:  false
      }
    }
    if (this.props.payment_method === 0) { // credit card
      window.lp_payment.handleTransaction({
        type: 'card',
        card: {
          number: this.props.card_number,
          cvc: !this.props.card_ccv.includes(' ') ? this.props.card_ccv : this.props.card_ccv.slice(0, 3),
          exp: this.props.card_expiration,
        },
        contract_id: this.props.contract_id,
        pack: this.props.contract_meta_id === 302 ? 'first_price' : selectedPack,
        options: [],
        pack_price: this.props.pack_price,
        upsell: this.props.upsell,
        invoice: lpApp.ops.checkout.isInvoiceActivated() ? lpApp.ops.checkout.getInvoice() : {},
        coupon: this.props.promo_code,
        client_email: this.props.mail,
        document_name: lpApp.contractTitle,
        cgv: this.props.confirmation,
        price: totalTTC,
        paymentMethod: 'stripe',
        revenue: this.totalRevenue(),
        ...datalayerData

      }).then((response) => {
        if (response.STATUS === 'SUCCESS') {
          window.localStorage.setItem('purchaseScore', response.purchaseScore);
          lpApp.setPayed(true)
          window.onbeforeunload = null;
          if (typeof (window.ga) !== 'undefined') {
            window.ga('send', 'event', 'Payment', 'Download', parseFloat(lpApp.ops.checkout.getTTCPrice()));
            window.ga('require', 'ecommerce');
            window.ga('ecommerce:addTransaction', {
              id: this.props.contract_id,
              affiliation: 'LegalPlace - Wizard',
              revenue: parseFloat(totalTTC),
              shipping: '0',
              tax: 0,
              currency: 'EUR',
            });
            window.ga('ecommerce:addItem', {
              id: this.props.contract_id, // Transaction ID. Required.
              name: lpApp.contractTitle, // Product name. Required.
              price: parseFloat(totalTTC), // Unit price.
              quantity: '1', // Quantity.
            });
            window.ga('ecommerce:send');
          }
          window.location.href = `${response.redirect}?react`;
        }
        this.props.unloading();
      }).catch(
        (err_) => {
          const errorMessage = err_ && err_.length && err_[0].message
          lpevents.trackErrorPaymentCheckout(errorMessage)
          let err;
          if (err_.gcv) {
            raiseError('credit-error', 12, err_.gcv);
            err = err_.ae;
          } else err = err_;
          if (err.length && err.length > 0) {
            err.forEach((idx) => {
              if (idx.hook === 'global') raiseError('credit-error', 10, idx.message);
              else raiseError(idx.hook, 10, idx.message);
            });
          }
          // test if the thing is Error type
          if (err instanceof Error) {
            raiseError('credit-error', 12, err.message);
          }
          this.props.unloading();
        },
      );
    } else {
      if (!this.props.confirmation) {
        raiseError('credit-error', 20, _lp("Vous devez lire et accepter nos conditions générales de vente et d'utilisation."));
        this.props.unloading();
        return;
      }
      let pack;
      switch (this.props.selected_pack) {
        case 0:
          pack = 'first_price';
          break;
        case 1:
          pack = 'second_price';
          break;
        default:
          pack = 'third_price';
          break;
      }
      window.lp_payment.handleTransaction({
        type: 'paypal',
        contract_id: this.props.contract_id,
        pack: this.props.contract_meta_id === 302 ? 'first_price' : pack,
        options: [],
        invoice: lpApp.ops.checkout.isInvoiceActivated() ? lpApp.ops.checkout.getInvoice() : {},
        coupon: this.props.promo_code,
        price: totalTTC,
        upsell: this.props.upsell,
        locale: 'fr_FR',
        pack_price: this.props.pack_price,
        client_email: this.props.mail,
        document_name: window.contractName,
        cgv: this.props.confirmation,
        paymentMethod: 'paypal',
        orderId: orderId || '',
        paypalAddress,
        revenue: this.totalRevenue(),
        ...datalayerData

      }).then((response) => {
        if (response.STATUS === 'SUCCESS') {
          window.localStorage.setItem('purchaseScore', response.purchaseScore);
          lpApp.setPayed(true)
          window.onbeforeunload = null;
          window.location.href = `${response.redirect}?react`;
        }
        this.props.unloading();
      }).catch((err_) => {
        const errorMessage = err_ && err_.length && err_[0].message
        lpevents.trackErrorPaymentCheckout(errorMessage)
        let err;
        if (err_.gcv) {
          raiseError('credit-error', 12, err_.gcv);
          err = err_.ae;
        } else err = err_;
        if (err.length && err.length > 0) {
          err.forEach((idx) => {
            if (idx.hook === 'global') raiseError('credit-error', 10, idx.message);
            else raiseError(idx.hook, 10, idx.message);
          });
        }
        // test if the thing is Error type
        if (err instanceof Error) {
          raiseError('credit-error', 12, err.message);
        }
        this.props.unloading();
      });
    }

    let pack;
    switch (this.props.selected_pack) {
      case 0:
        pack = 'first_price';
        break;
      case 1:
        pack = 'second_price';
        break;
      default:
        pack = 'third_price';
        break;
    }

    const eventParams = {};
    eventParams['Chosen price'] = this.props.price[pack];
    eventParams['Total price'] = totalTTC;
    eventParams['Chosen pack'] = pack;
    eventParams['Payment method'] = this.props.payment_method === 0 ? 'Stripe' : 'Paypal';

    lpevents.track('Asked Payment', eventParams);
    lpevents.trackClickPayment()
  }

  render() {
    const totalTTC = this.props.contract_meta_id === 302 ? this.props.totalTTC : parseFloat(lpApp.ops.checkout.getTTCPrice())

    return (
      <div ref="credit_card_modal">
        {this.props.show
            && (
            <div className="lpm-container">
              <div ref="close_btn" className="lpm-close icn-x"/>
              <div className="lpm-title">
                <i className="icn-lock" />
                {_lp('Paiement sécurisé')}
              </div>
              <div ref="content_modal" className="lpm-content">
                {this.props.credit_error
                    && (
                    <div className="alert error">
                      <span>{this.props.credit_error.message}</span>
                    </div>
                    )}
                <div className="chekout-tabs">

                  <div className={`checkout-tab active`} id="ct-cards">
                      <div className="ct-content">
                        <form id="form-payement">

                          <div className={`form-group form-payement__card-number ${this.state.card_class}${this.props.error_card ? ' error' : ''}`}>
                            <div className="fg-wrapper">
                              <label>Numéro de carte</label>
                              <MaskedInput mask="!!!! !!!! !!!! !!!!" className="form-control" name="cardnumber" autoComplete="cc-number" value={this.props.card_number} onChange={this.updateCardNumber} />
                              {' '}
                              {this.props.error_card && <span className="help-block">{ this.props.error_card.message }</span>}
                            </div>
                          </div>
                          <div className="row">
                            <div className={`form-group col-sm-6 form-payement__exp-date${this.props.error_exp ? ' error' : ''}`}>
                              <div className="fg-wrapper">
                                <label>Date d'expiration</label>
                                <MaskedInput placeholder={_lp('MM/AA')} mask="!!/!!" maxLength="5" className="form-control" name="cardexp" autoComplete="cc-exp" value={this.props.card_expiration} onChange={this.updateCardExpiration} />
                                {this.props.error_exp && <span className="help-block">{ this.props.error_exp.message }</span>}
                              </div>
                            </div>
                            <div className={`form-group col-sm-6 form-payement__cvc${this.props.error_cvc ? ' error' : ''}`}>
                              <div className="fg-wrapper">
                                <label>Crypto (CVC)</label>
                                <MaskedInput mask="!!!!" className="form-control" autoComplete="cc-csc" value={this.props.card_ccv} onChange={this.updateCardCCV} />
                                {this.props.error_cvc && <span className="help-block">{ this.props.error_cvc.message }</span>}
                              </div>
                            </div>
                          </div>
                          <div className="checkout-payment cp-flexy">
                            <div className="form-group checkout-conditions">
                              <input type="checkbox" id="check_stripe" value={this.props.confirmation} onClick={this.updateCheckBox} />
                              <label htmlFor="check_stripe">
En cochant cette case, j'accepte les
                                <a href="/conditions-generales" target="_blank">
                                  {' '}
                                  conditions générales
                                </a>
                              </label>
                            </div>
                            <a className={`btn btn-block btn-primary cta-payement${this.props.loading_payment ? ' checking' : ''}`} onClick={this.props.loading_payment ? () => {} : () => this.initiatePayment()}>
                              <span className="loading-spin" />
                              <span className="btn-text">
Acheter
                                <span>
                                  {' '}
                                  {totalTTC.toFixed(2)}
                                  {' '}
                                  €
                                </span>
                              </span>
                            </a>
                          </div>
                        </form>
                      </div>
                  </div>
                  <div className="ct-spacer"><span>Ou acheter par</span></div>
                  <div className={`checkout-tab${this.props.payment_method === 1 ? ' active' : ''}`} id="ct-paypal">
                    <div id="paypal-container-wrapper">
                      <div id="paypal-container">
                    </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lmc-footer lpm-footer">
Besoin d'aide? Appelez-nous au
                <strong>
                  {' '}
                  {lpApp.supportPhone}
                </strong>
                {' '}
              </div>
            </div>
            )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  payment_method: state.checkout_operations.payment_method,
  card_number: state.checkout_operations.credit_card.number,
  card_expiration: state.checkout_operations.credit_card.expiration,
  card_ccv: state.checkout_operations.credit_card.ccv,
  contract_id: state.checkout_operations.contract_id,
  contract_meta_id: state.checkout_operations.contract_meta_id,
  selected_pack: state.checkout_operations.pack,
  price: state.checkout_operations.prices,
  call_chosen: state.checkout_operations.has_call,
  letter_chosen: state.checkout_operations.has_letter,
  // now with the letter informayion
  letter_number: state.checkout_operations.letter.number,
  letter_zip: state.checkout_operations.letter.zip,
  letter_city: state.checkout_operations.letter.city,
  letter_address: state.checkout_operations.letter.address,
  letter_name: state.checkout_operations.letter.name,
  // coupone code
  promo_code: state.checkout_operations.promo_code,
  confirmation: state.checkout_operations.confirm,
  promo_percentage: state.checkout_operations.promo_percentage,
  pack_price: state.checkout_operations.pack === 0
    ? state.checkout_operations.prices.first_price
    : state.checkout_operations.prices.second_price,
  coursier_pack_price: state.checkout_operations.prices.first_price,
  // the errors are here
  credit_error: state.errors.components['credit-error'],
  error_card: state.errors.components['card.number'],
  error_exp: state.errors.components['card.exp'],
  error_cvc: state.errors.components['card.cvc'],
  // payment loading
  loading_payment: state.loading_details.checking_payment,
  // For payment add
  mail: state.account_settings.mail,
});


const mapDispatchToProps = (dispatch) => {
  const l = store.getState().document_state.state;
  if (l === 'new') {
    // dispatch({type: SET_DOCUMENT_ID, doc: d})
  }
  return {
    updatePaymentMethod: (meth) => {
      dispatch(ckPaymentSelect(meth));
    },
    updateCardNumber: (val) => {
      dispatch(ckCUpdateCardNumber(val));
    },
    updateCardExpiration: (val) => {
      dispatch(ckCUpdateCardExpiration(val));
    },
    updateCardCCV: (val) => {
      dispatch(ckCUpdateCCV(val));
    },
    updateConfirmation: (val) => {
      dispatch({ type: CK_CHECK, val });
    },
    loading: () => {
      dispatch(checkingPayment(true));
    },
    unloading: () => {
      dispatch(checkingPayment(false));
    },
  };
};

const LpCreditCardModal = connect(mapStateToProps, mapDispatchToProps)(_LpCreditCardModal);

export default LpCreditCardModal;



// WEBPACK FOOTER //
// ./src/components/buy/card_modal.js